import { FC } from "react";
import { Outlet } from "react-router-dom";
import styles from "./AppFrame.module.scss";
import AppLogo from "./AppLogo";
import TopBar from "./TopBar";

type AppFrameProps = {
  logo: string;
  title?: string;
};

const AppFrame: FC<AppFrameProps> = ({ logo, title }) => {
  return (
    <div className={styles.appFrame}>
      <TopBar />
      <div className={styles.scrollWrapper}>
        <div className={styles.centerWrapper}>
          <AppLogo logo={logo} title={title} />
          <div className={styles.content}>{<Outlet />}</div>
        </div>
      </div>
    </div>
  );
};

export default AppFrame;
